module.exports = __webpack_public_path__ + "img/QUALITY.0fa09b11.svg";